import exportWithNotification from 'exports/exportWithNotification';

import * as PipelineDAO from './PipelineDAO';

export function exportSavedResultsDataFrame(stepId: string): void {
  exportWithNotification(async () => await PipelineDAO.exportSavedResultsDataFrame(stepId));
}
